var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.$vuetify.breakpoint.mdAndUp ? _c('div', {
    staticClass: "top_info top_info_container price"
  }, [_c('div', {
    staticClass: "data"
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("dcm price")]), _c('p', {
    staticClass: "content usd-before"
  }, [_vm.price ? _c('span', [_vm._v(_vm._s(parseFloat(_vm.price.usd).toFixed(2)))]) : _c('span', [_vm._v("N/A")])]), _c('p', {
    staticClass: "description dcm-after"
  }, [_vm._v("1")])]), _vm.theme ? _c('div', {
    staticStyle: {
      "width": "200px",
      "height": "150px"
    }
  }, [_c('canvas', {
    ref: "validators_graph",
    staticClass: "validators_graph"
  })]) : _vm._e()]) : _c('div', {
    staticClass: "top_info top_info_container price"
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("dcm price")]), _c('p', {
    staticClass: "content usd-before"
  }, [_vm.price ? _c('span', [_vm._v(_vm._s(parseInt(_vm.price.usd).toFixed(2)))]) : _c('span', [_vm._v("N/A")])]), _c('p', {
    staticClass: "description dcm-after"
  }, [_vm._v("1")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }